import React from "react";
import { useApp } from "../context/AppContext";
import { FAQ, TX } from "../data";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../components/ui/accordion";

const FaqPage = () => {
  const { lang } = useApp();
  const tx = TX[lang];
  return (
    <main className="max-w-[820px] mx-auto px-6 py-16 md:py-24 min-h-[70vh]">
      <span className="text-[11px] tracking-label uppercase text-[#B4715C]">{tx.faqKicker}</span>
      <h1 className="mt-4 font-serif font-light text-5xl md:text-6xl text-[#3A2C28] leading-[1.02]">{tx.faqTitle}</h1>

      <Accordion type="single" collapsible className="mt-12 space-y-3">
        {FAQ.map((item, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="bg-white rounded-2xl border border-[#EEE0D7] px-6">
            <AccordionTrigger className="text-left font-serif text-xl text-[#3A2C28] hover:no-underline py-5">
              {item.q[lang]}
            </AccordionTrigger>
            <AccordionContent className="text-[15px] leading-relaxed text-[#6E5A52] pb-5">
              {item.a[lang]}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </main>
  );
};

export default FaqPage;
